import { EpimsBaseEntityDto } from './epim-base.dto';
export class AppConfigurationDto extends EpimsBaseEntityDto {
  type: string;
  SubscriptionUserId: string;
  leftvalue: string;
  rightvalue: string;
}
